import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';
import { useDividendDocumentModal } from '../context/DividendDocumentModalContext';

const DividendDocumentModalHeader = () => {
  const { t } = useTranslate();

  const { actions } = useDividendDocumentModal();

  return (
    <Modal.Header>
      <h4 className="modal-title">
        <span>{t('GenerateDividendDocuments')}</span>
      </h4>

      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default DividendDocumentModalHeader;
